<template>
  <div>
    <DialogBottomSheet
      :is-visible="isDialogOpened"
      :width="isMobile ? undefined : 375"
      content-class="rounded-0"
      @input="filtersStore.resetUnsavedFilters"
      @dialog-bottom-sheet:change-visible="closeDialog"
    >
      <v-card
        tile
        class="pt-6 px-4 pb-4"
      >
        <v-form @submit.prevent="applyFilter">
          <RadioGroupAppointment
            v-model="filtersStore.unsavedFilters"
          >
            <template #title>
              <div class="text-h6 mb-2">
                {{ t('Запись на приём', options) }}
              </div>
            </template>
          </RadioGroupAppointment>
          <BtnShowDoctors
            class="mt-4"
            :active="isDialogOpened"
            @click:close="closeDialog"
            @click:submit="applyFilter"
          />
        </v-form>
      </v-card>
    </DialogBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import I18NextVue from 'i18next'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import RadioGroupAppointment from 'www/vue_components/common/TheFilters/doctors/components/VisitLocationFilters/components/RadioGroupAppointment/RadioGroupAppointment.vue'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('VisitLocationFilters')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const isMobile = window.MOBILE_VERSION

watch(
  () => filtersStore.filters.visitLocation,
  () => {
    const name = ({
      clinic: t('В клинике', options.value),
      home: t('На дому', options.value),
      online: t('Онлайн', options.value),
    })[filtersStore.filters.visitLocation]

    chipsStore.updateVisitLocationChip({
      name,
      isActive: true,
      dropdown: true,
      isVisible: true,
      onClick: openDialog,
    })
  },
  { immediate: true },
)

const applyFilter = async () => {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  await updateDoctorListPage()
}
</script>
